<script setup lang="ts">
import Message from 'primevue/message'
import { computed } from 'vue'
import { useTranslation } from 'i18next-vue'
import { getFormatStateMeta, type FormatState } from '@/constants/formatState'
import type { TagSeverity } from '@/types/statusTag'

const props = withDefaults(
    defineProps<{
        state?: FormatState
        hasDraftVersion?: boolean
        severity?: TagSeverity
        message?: string
        icon?: string
        pt?: Record<string, unknown>
    }>(),
    {
        hasDraftVersion: false,
        state: undefined,
        severity: undefined,
        message: undefined,
        icon: undefined,
        pt: undefined,
    }
)

const { t } = useTranslation()

const statusMeta = computed(() => {
    if (!props.state) {
        return { severity: props.severity, message: props.message }
    }
    const base = getFormatStateMeta({
        state: props.state,
        hasDraftVersion: props.hasDraftVersion ?? false,
    })
    if (props.severity !== undefined || props.message !== undefined) {
        return { severity: props.severity ?? base.severity, message: props.message ?? base.message }
    }
    return base
})
</script>
<template>
    <Message
        v-if="statusMeta.message"
        :severity="statusMeta.severity"
        :pt="pt"
        fluid
        class="flex justify-center"
    >
        <div class="flex flex-col items-center gap-2 lg:flex-row lg:justify-center lg:gap-3">
            <div class="flex items-center gap-3">
                <i v-if="icon" :class="icon" aria-hidden="true" tabindex="-1" />
                <p>{{ t(statusMeta.message) }}</p>
            </div>
            <slot name="action" />
        </div>
    </Message>
</template>
